
import Footer from "@/components/Footer";
import { Header } from "@/components/landing/Header";
import { CircleCheck } from "lucide-react";
import { Suspense } from "react";

const RefundsPolicy = () => {
    return (
        <>
            <Header />
            <main className="flex min-h-full items-center justify-center bg-stone-50 dark:bg-stone-950 px-4 py-24">
                <div className="container max-w-4xl mx-auto px-4">
                    <h1 className="text-3xl font-bold mb-8 text-center dark:text-white">Refund Policy</h1>

                    <div className="rounded-lg p-8 mb-8">
                        <h2 className="text-2xl font-semibold mb-6 text-center dark:text-white">Simple and Straightforward</h2>

                        <div className="space-y-6">
                            <p className="text-lg dark:text-stone-500">We want you to be completely satisfied with our IELTS practice service. If you're not happy with your purchase for any reason, we're here to help.</p>

                            <div className="bg-blue-50 dark:bg-stone-800 border border-blue-100 dark:border-stone-700 rounded-lg p-6">
                                <h3 className="text-xl font-medium mb-3 dark:text-white">Our Promise</h3>
                                <p className="text-lg dark:text-stone-500">Full refund within 30 days of purchase - no questions asked.</p>
                            </div>

                            <div className="mt-8">
                                <h3 className="text-xl font-medium mb-3 dark:text-white">How to Request a Refund</h3>
                                <p className="text-lg mb-4 dark:text-stone-500">Simply email us at contact@ieltswith.ai with:</p>
                                <ul className="list-disc pl-8 space-y-2 text-lg dark:text-stone-500">
                                    <li>Your account email</li>
                                    <li>Message saying you'd like to request a refund. We'll appreciate if you explain why, but that's completely up to you.</li>
                                </ul>
                            </div>

                            <div className="bg-gray-50 dark:bg-stone-800 rounded-lg p-6 mt-8">
                                <h3 className="text-xl font-medium mb-3 dark:text-white">What to Expect</h3>
                                <ul className="space-y-3 text-lg dark:text-stone-500">
                                    <li className="flex items-start gap-3">
                                        <CircleCheck className="h-5 w-5 md:h-7 md:w-7 flex-shrink-0 text-orange-500" />
                                        Quick response within 24 hours
                                    </li>
                                    <li className="flex items-start gap-3">
                                        <CircleCheck className="h-5 w-5 md:h-7 md:w-7 flex-shrink-0 text-orange-500" />
                                        Refund processed to your original payment method
                                    </li>
                                </ul>
                            </div>

                            <div className="text-sm text-gray-600 dark:text-stone-400 mt-8">
                                <p>Note: While we offer a no-questions-asked refund policy, we reserve the right to decline refunds in cases of apparent abuse or fraud.</p>
                            </div>
                        </div>
                    </div>

                    <div className="text-center">
                        <p className="text-lg dark:text-stone-500">Still have questions? Email us at contact@ieltswith.ai</p>
                    </div>
                </div>
            </main>
            <Suspense fallback={<div className="h-16" />}>
                <Footer />
            </Suspense>
        </>
    );
};

export default RefundsPolicy;
